export const globalSettingsSystemAuditingRoute = {
	name: 'global-settings-system-auditing',
	path: '/auditing/:page',
};
